export function sanitizeEncipherencode(value) {
  if (!value) return null;
  const trimmed = value.toString().trim();
  if (
    trimmed.toLowerCase() === "undefined" ||
    trimmed.toLowerCase() === "null" ||
    trimmed === ""
  ) {
    return null;
  }
  return trimmed;
}

export function hasValidEncipherencode(value) {
  return Boolean(sanitizeEncipherencode(value));
}

export function canUsePersistedMerchantConfig(encipherencode, merchantConfig) {
  return (
    hasValidEncipherencode(encipherencode) &&
    Boolean(
      merchantConfig &&
        typeof merchantConfig === "object" &&
        Object.keys(merchantConfig).length > 0,
    )
  );
}

export function getEncipherencode(searchParams) {
  const paramValue = sanitizeEncipherencode(
    searchParams?.get?.("encipherencode") ?? null
  );

  if (paramValue) return paramValue;

  try {
    return sanitizeEncipherencode(
      window.sessionStorage.getItem("encipherencode")
    );
  } catch (error) {
    // iframe / sandbox / cross-origin safe
    return null;
  }
}
